import axios from 'axios';
import 'whatwg-fetch';

export function getAntiForgeryToken(): string {
	return (document.querySelector('#__AjaxAntiForgeryForm input') as HTMLInputElement).value;
} 

export function get<T>(url: string, params?: any): Promise<T> {

	let ts = new Date().getTime();
	var newParams = {...params, _: ts.toString() }
	
	const prom = new Promise<T>(function (resolve, reject) {
		axios.get(url, {
			params: newParams,
			headers: {
				'Cache-Control': "no-store"
			}
		})
			.then(x => resolve(x.data))
			.catch(x => reject(x));
	});

	return prom;
}

export function fetchGet(url: string, params?: any): Promise<Response> {
	let ts = new Date().getTime();
	var newParams = { ...params, _: ts.toString() }

	var query = Object.keys(newParams)
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(newParams[k]))
		.join('&');

	return fetch(url + "?" + query, {
		credentials: "same-origin",
		cache: "no-store"
	});
}

export function post(url: string, data?: any) {

	return fetch(url, {
		credentials: "same-origin",
		cache: "no-store",
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'__RequestVerificationToken': getAntiForgeryToken(),
		},
		body: JSON.stringify(data)
	});
}

export function postFormParams(url: string, data: {[key: string]: string}) {

	data["__RequestVerificationToken"] = getAntiForgeryToken();
	return axios.post(url, transformRequest(data));
}

const transformRequest = (jsonData: { [key: string]: string }) =>
	Object.entries(jsonData)
		.map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
		.join('&');

export function postFormData(url: string, data: FormData) {
	
	return fetch(url, {
		credentials: "same-origin",
		cache: "no-store",
		method: 'POST',
		body: data
	});
}